<template lang="pug">
.generic-section__controllers
  tooltip-wrap(
    text="Создать секцию сверху"
    :top="false"
    right
  )
    v-btn(
      color="secondary lighten-1"
      fab
      depressed
      text
      @click="$emit('add:before')"
    ).mb-2
      strong +
  tooltip-wrap(
    text="Переместить секцию наверх"
    :top="false"
    right
  )
    v-btn(
      color="secondary lighten-1"
      fab
      depressed
      text
      :disabled="first"
      @click="$emit('move:before')"
    ).mb-2
      v-icon mdi-chevron-up
  tooltip-wrap(
    text="Удалить секцию"
    :top="false"
    right
  )
    v-btn(
      color="error darken-1"
      fab
      depressed
      text
      :disabled="!canDeleteFirst && first && last"
      @click="$emit('remove')"
    ).mb-2
      v-icon mdi-delete-outline

  tooltip-wrap(
    text="Переместить секцию вниз"
    :top="false"
    right
  )
    v-btn(
      color="secondary lighten-1"
      fab
      depressed
      text
      :disabled="last"
      @click="$emit('move:after')"
    ).mb-2
      v-icon mdi-chevron-down
  tooltip-wrap(
    text="Создать секцию снизу"
    :top="false"
    right
  )
    v-btn(
      color="secondary lighten-1"
      fab
      depressed
      text
      @click="$emit('add:after')"
    ).mb-2
      strong +
</template>
<script>
export default {
  props: {
    first: { type: Boolean, default: false },
    last: { type: Boolean, default: false },
    canDeleteFirst: { type: Boolean, default: false },
  },
};
</script>
